import { T } from "@supersig/validate";
import { swFontResourceReference } from "./resource";
//
// Color
//
const cssColorValue = T.object({
    type: T.literal("css-color"),
    value: T.string
});
//
// Font Family
//
const _cssFontFaceValue = T.object({
    type: T.literal("css-font"),
    value: T.string,
    weight: T.string,
    // Is something like '500italic' | 'italic' | '500' | 'normal' | 'regular'
    variant: T.string.optional(),
    // undefined implies system... I think
    kind: T.literalEnum("system", "google", "custom").optional(),
    style: T.string,
    url: T.string.optional(),
    // resourceId
    // allow us to override values based on the resourceId
    resourceReference: swFontResourceReference.optional()
});
const cssFontFaceValue = _cssFontFaceValue;
//
// Length
//
const cssLengthValuePx = T.object({
    type: T.literal("css-length"),
    unit: T.literal("px"),
    value: T.string
});
const cssLengthValuePercent = T.object({
    type: T.literal("css-length"),
    unit: T.literal("%"),
    value: T.string
});
const csslengthValueVw = T.object({
    type: T.literal("css-length"),
    unit: T.literal("vw"),
    value: T.string
});
const csslengthValueVh = T.object({
    type: T.literal("css-length"),
    unit: T.literal("vh"),
    value: T.string
});
const csslengthValueRem = T.object({
    type: T.literal("css-length"),
    unit: T.literal("rem"),
    value: T.string
});
const csslengthValueEm = T.object({
    type: T.literal("css-length"),
    unit: T.literal("em"),
    value: T.string
});
const csslengthValueAuto = T.object({
    type: T.literal("css-length"),
    unit: T.literal("none"),
    value: T.literal("auto")
});
const csslengthValueInherit = T.object({
    type: T.literal("css-length"),
    unit: T.literal("none"),
    value: T.literal("inherit")
});
const csslengthValueInitial = T.object({
    type: T.literal("css-length"),
    unit: T.literal("none"),
    value: T.literal("initial")
});
const csslengthValueUnset = T.object({
    type: T.literal("css-length"),
    unit: T.literal("none"),
    value: T.literal("unset")
});
const cssLengthValueNoneUnit = T.union("value", {
    auto: csslengthValueAuto,
    inherit: csslengthValueInherit,
    initial: csslengthValueInitial,
    unset: csslengthValueUnset
});
const cssLengthString = T.object({
    type: T.literal("css-length"),
    unit: T.literal("raw"),
    value: T.string
});
const cssLengthValue = T.union("unit", {
    px: cssLengthValuePx,
    "%": cssLengthValuePercent,
    vw: csslengthValueVw,
    vh: csslengthValueVh,
    rem: csslengthValueRem,
    em: csslengthValueEm,
    none: cssLengthValueNoneUnit,
    raw: cssLengthString
});
//
// Percentage
//
const cssOpacityValuePercentage = T.object({
    type: T.literal("css-percentage"),
    unit: T.literal("%"),
    value: T.string
});
const cssOpacityUnit = T.union("value", {
    auto: T.object({
        type: T.literal("css-percentage"),
        unit: T.literal("none"),
        value: T.literal("auto")
    }),
    inherit: T.object({
        type: T.literal("css-percentage"),
        unit: T.literal("none"),
        value: T.literal("inherit")
    }),
    initial: T.object({
        type: T.literal("css-percentage"),
        unit: T.literal("none"),
        value: T.literal("initial")
    }),
    unset: T.object({
        type: T.literal("css-percentage"),
        unit: T.literal("none"),
        value: T.literal("unset")
    })
});
const cssOpacityValue = T.union("unit", {
    none: cssOpacityUnit,
    "%": cssOpacityValuePercentage
});
//
// arbitrary number
//
const cssNumberUnitValue = T.object({
    type: T.literal("css-number-unit"),
    value: T.string,
    unit: T.string.optional()
});
//
// Enums
//
// Display
export const cssDisplayOptions = [
    "block",
    "inline",
    "inline-block",
    "flex",
    "none"
];
// Flex
export const cssFlexDirectionOptions = [
    "row",
    "column",
    "row-reverse",
    "column-reverse"
];
export const cssFlexAlignOptions = [
    "start",
    "end",
    "center",
    "stretch",
    "baseline"
];
export const cssFlexJustifyOptions = [
    "flex-start",
    "flex-end",
    "center",
    "space-between",
    "space-around"
];
export const cssFlexWrapOptions = [
    "wrap",
    "nowrap",
    "reverse",
    "inherit",
    "initial",
    "revert",
    "unset"
];
// Overflow
const cssOverflowOptions = [
    "auto",
    "hidden",
    "visible",
    "scroll"
];
// Position
const cssPositionOptions = [
    "absolute",
    "relative",
    "fixed",
    "static",
    "sticky"
];
// Border Value
export const cssBorderStyleOptions = [
    "none",
    "solid",
    "dashed",
    "dotted",
    "double",
    "groove",
    "ridge",
    "inset",
    "outset"
];
// Font
const cssFontWeightOptions = [
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900",
    "auto",
    "inherit",
    "initial",
    "unset"
];
// Font Style
const cssFontStyleOptions = [
    "normal",
    "italic"
];
// Text Align
const cssTextAlignOptions = [
    "left",
    "center",
    "right",
    "justify"
];
// Text Decoration
const cssTextDecorationLineOptions = [
    "none",
    "line-through",
    "underline",
    "overline"
];
// Text Transform
const cssTextTransformOptions = [
    "none",
    "capitalize",
    "uppercase",
    "lowercase"
];
export const cssEnumTypeMap = {
    "css-display": cssDisplayOptions,
    "css-flex-direction": cssFlexDirectionOptions,
    "css-flex-align-items": cssFlexAlignOptions,
    "css-flex-justify-content": cssFlexJustifyOptions,
    "css-flex-wrap": cssFlexWrapOptions,
    "css-font-weight": cssFontWeightOptions,
    "css-font-style": cssFontStyleOptions,
    "css-text-align": cssTextAlignOptions,
    "css-text-decoration": cssTextDecorationLineOptions,
    "css-text-transform": cssTextTransformOptions,
    "css-overflow": cssOverflowOptions,
    "css-position": cssPositionOptions,
    "css-border-style": cssBorderStyleOptions
};
//
// Transform
//
const cssTransformTranslateValue = T.object({
    type: T.literal("css-transform-translate"),
    value: T.string.optional(),
    x: cssLengthValue.optional(),
    y: cssLengthValue.optional()
});
const cssTranformScaleValue = T.object({
    type: T.literal("css-transform-scale"),
    value: cssNumberUnitValue
});
const cssTransformRotateValue = T.object({
    type: T.literal("css-transform-rotate"),
    value: cssNumberUnitValue
});
//
// Transition
//
export const cssTransitionValue = T.object({
    type: T.literal("css-transition"),
    property: T.string,
    duration: cssNumberUnitValue,
    timingFunction: T.string,
    delay: cssNumberUnitValue,
    value: T.string.optional()
});
//
// Box Shadow
//
export const cssBoxShadow = T.object({
    type: T.literal("css-box-shadow"),
    xOffset: cssNumberUnitValue,
    yOffset: cssNumberUnitValue,
    blurRadius: cssNumberUnitValue,
    spreadRadius: cssNumberUnitValue,
    color: cssColorValue,
    inset: T.boolean,
    value: T.string.optional()
});
//
// Filter
//
const blurFilter = T.object({
    type: T.literal("blur"),
    value: cssLengthValue
});
const cssFilterFunction = T.union("type", {
    blur: blurFilter
});
export const cssFilterValue = T.object({
    type: T.literal("css-filter"),
    filters: T.arrayOf(cssFilterFunction),
    value: T.string.optional()
});
//
// Backdrop Filter
//
export const cssBackdropFilterValue = T.object({
    type: T.literal("css-backdrop-filter"),
    filters: T.arrayOf(cssFilterFunction),
    value: T.string.optional()
});
//
// Background Image
//
export const cssBackgroundImageGradientStop = T.object({
    color: cssColorValue,
    position: cssNumberUnitValue
});
export const cssBackgroundImageLinearGradient = T.object({
    type: T.literal("linearGradient"),
    angle: cssNumberUnitValue,
    stops: T.arrayOf(cssBackgroundImageGradientStop)
});
export const cssBackgroundImageRadialGradient = T.object({
    type: T.literal("radialGradient"),
    shape: T.literalEnum("circle", "ellipse"),
    stops: T.arrayOf(cssBackgroundImageGradientStop)
});
export const cssBackgroundImageUrl = T.object({
    type: T.literal("image"),
    url: T.string.optional(),
    size: T.string.optional(),
    verticalPosition: T.string.optional(),
    horizontalPosition: T.string.optional()
});
export const cssBackgroundImageFunction = T.union("type", {
    linearGradient: cssBackgroundImageLinearGradient,
    radialGradient: cssBackgroundImageRadialGradient,
    image: cssBackgroundImageUrl
});
export const cssBackgroundImageValue = T.object({
    type: T.literal("css-background-image"),
    functions: T.arrayOf(cssBackgroundImageFunction),
    value: T.string.optional()
});
//
// String
//
const a = T.literal("a").optional();
const cssStringValue = T.object({
    type: T.literal("css-string"),
    // A type hint, that is used to know what type of value we're editing for
    // showing enums using icons.
    cssEnumHint: T.setEnum(new Set(Object.keys(cssEnumTypeMap))).optional(),
    value: T.string
});
export const cssTypeMap = {
    "css-color": cssColorValue,
    "css-font": cssFontFaceValue,
    "css-length": cssLengthValue,
    "css-percentage": cssOpacityValue,
    "css-transform-translate": cssTransformTranslateValue,
    "css-transform-scale": cssTranformScaleValue,
    "css-transform-rotate": cssTransformRotateValue,
    "css-transition": cssTransitionValue,
    "css-number-unit": cssNumberUnitValue,
    "css-background-image": cssBackgroundImageValue,
    "css-filter": cssFilterValue,
    "css-backdrop-filter": cssBackdropFilterValue,
    "css-string": cssStringValue,
    "css-box-shadow": cssBoxShadow
};
export const cssValue = T.union("type", cssTypeMap);
/**
 * Converts the literal to the right-hand side of the CSS property
 * to be passed to the DOM
 */ export const cssPropertyToDom = (literal)=>{
    switch(literal.type){
        case "css-string":
        case "css-color":
            return literal.value;
        case "css-length":
            const lengthLiteral = literal;
            switch(lengthLiteral.unit){
                case "raw":
                case "none":
                    return lengthLiteral.value;
                default:
                    return lengthLiteral.value + lengthLiteral.unit;
            }
        case "css-percentage":
            const percentageLiteral = literal;
            if (percentageLiteral.unit === "none") {
                return percentageLiteral.value;
            }
            return percentageLiteral.value + percentageLiteral.unit;
        case "css-font":
            const fontFamilyLiteral = literal;
            return fontFamilyLiteral.value;
        default:
            return undefined;
    }
};
